import { useI18nContext } from "@hopper-b2b/i18n";
import { ActionLink } from "@hopper-b2b/ui";
import clsx from "clsx";

interface WatchTripSuccessProps {
  cn: (elementName: string) => string;
  onClose: () => void;
}

export const WatchTripSuccess = ({
  cn,
  onClose,
}: WatchTripSuccessProps): JSX.Element => {
  const {
    t,
    brand: { urls },
  } = useI18nContext();
  return (
    <div className={cn("success-view")}>
      <p className={cn("subtitle")}>{t("priceWatch.successTitle")}</p>

      <p className={cn("description")}>{t("priceWatch.successMessage")}</p>

      <ActionLink
        className={cn("terms-and-conditions-link")}
        content={t("termsAndConditions")}
        onClick={() => window.open(urls.termsAndConditions, "_blank")}
      ></ActionLink>

      <button
        className={clsx(cn("cta-button"), "cta-button")}
        type="submit"
        onClick={onClose}
      >
        {t("done")}
      </button>
    </div>
  );
};
